import type { TFunction } from 'i18next';
import { DateTime } from 'luxon';

/** Mon–Sun, aligned with Luxon `weekday` (1 = Monday … 7 = Sunday). */
const WEEKDAY_LABEL_KEYS = [
  'reservation.monday',
  'reservation.tuesday',
  'reservation.wednesday',
  'reservation.thursday',
  'reservation.friday',
  'reservation.saturday',
  'reservation.sunday',
] as const;

/**
 * Turns machine-produced ISO datetimes (comma-separated) into localized strings:
 * `{{weekday}} {{at}} {{time}}` per segment, joined with commas
 */
export function formatStandingOrderPickupDateTimesCsv(
  isoCsv: string,
  t: TFunction,
): string {
  const trimmed = isoCsv.trim();
  if (!trimmed) return '';

  const at = t('reservation.at');
  const segments: string[] = [];

  for (const raw of trimmed.split(',')) {
    const isoString = raw.trim();
    if (!isoString) continue;

    const thisDateTime = DateTime.fromISO(isoString);
    if (!thisDateTime.isValid) continue;

    const labelKey = WEEKDAY_LABEL_KEYS[thisDateTime.weekday - 1];
    if (!labelKey) continue;

    segments.push(
      `${t(labelKey)} ${at} ${thisDateTime.toLocaleString(DateTime.TIME_SIMPLE)}`,
    );
  }

  return segments.join(', ');
}
